const initialFileTypeDataState = {
  data : false,
  columns: false

} 

export const FileTypeDataReducer = (state = initialFileTypeDataState, action = {}) => {    
    
    switch (action.type) {    
        
        case 'FILETYPEDATA':  
      
            return {
              ...state,
              data: action.fetchedFileTypeData.data.data,
              columns: action.fetchedFileTypeData.data.columns

            }
        
     
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FileTypeDataReducer.js